"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const caretup = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-caretup" : '') + (description ? " desc-caretup" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-caretup"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-caretup"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 5.98958C11.5708 5.98958 11.1586 6.14758 10.854 6.42958L1.02784 15.5133L0.948547 15.5973C0.657505 15.9588 0.694309 16.4487 1.02778 16.7571L1.12351 16.8345C1.48968 17.0925 2.01229 17.0667 2.3472 16.7571L12 7.83245L21.6528 16.7571L21.7435 16.8303C22.1274 17.0944 22.6433 17.0612 22.9723 16.7571C23.3426 16.4146 23.3426 15.8557 22.9722 15.5133L13.1455 6.42911L13.0359 6.3368C12.7369 6.10974 12.3743 5.98958 12 5.98958Z",
    fill: "inherit"
  }));
};
var _default = exports.default = caretup;